/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { Classes, Icon as BPIcon } from '@blueprintjs/core';
import styled from '@emotion/styled';
import * as iconPaths from './icons.json';

// Props to Nancy O`Brien for finding Icomoon and figuring out how to use it in a react application.
// Upload icons.json to https://icomoon.io/app/#/select to see available icons and names.

function findIcon(iconName) {
  return iconPaths.icons.find(i => i.properties.name === iconName);
}

export function getPath(iconName) {
  const icon = findIcon(iconName);
  return icon ? icon.icon.paths.join(' ') : '';
}

export function isValidIcon(iconName) {
  return !!findIcon(iconName);
}

export function getIconLabel(iconName) {
  const icon = findIcon(iconName);
  if (icon) {
    return (icon.tags && icon.tags[0]) || icon.properties.name;
  } else {
    return '';
  }
}

export function Icon({ icon, iconSize = 16, className = '', includeTitle=true}) {
  if (isValidIcon(icon)) {
    return (
      <SvgIcon
        className={`${Classes.ICON} ${className}`}
        data-icon={icon}
        width={iconSize}
        height={iconSize}
        viewBox="0 0 1024 1024"
      >
        {includeTitle ? <title>{getIconLabel(icon)}</title> : null}
        <g className={icon}>
          <path d={getPath(icon)}/>
        </g>
      </SvgIcon>
    );
  } else {
    return <BPIcon icon={icon} iconSize={iconSize}/>;
  }
}

const SvgIcon = styled.svg`
  path {
    fill: ${props => (props.color ? props.color : 'currentColor')};
    stroke: ${props => (props.color ? props.color : 'currentColor')};
  }
`;

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.any,
  iconSize: PropTypes.number,
  style: PropTypes.object,
  includeTitle: PropTypes.bool,
};
